import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop } from 'lodash';
import StudentReportFilter from '../../../../components/Filter/StudentReport.filter.component';
import ListForm from '../../../../components/ListForm/ListForm.component';
import ContentTable from '../../../../components/ContentTable/ContentTable.component';
import { validateRequiredFields } from '../../../../utils/validation.util';
import { commaFormatted, normalizeAmount } from '../../../../utils/transformer.util';
import { Input, Select, Button } from '../../../../components/base/index';
import IndividualForm from './components/IndividualForm.component';
import IndividualTable from './components/IndividualTable.component';
export default class Individual extends Component {
    constructor(props) {
        super(props);
        this._onClickSubmit = this._onClickSubmit.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this._onSubmit2 = this._onSubmit2.bind(this);
        this._onSubmit3 = this._onSubmit3.bind(this);
        this._onFormChange = this._onFormChange.bind(this);
      
        this.state= {
          coa: {
            loading: true,
            list: [],
    
          },
          form: {
            value: {},
            error: {},
          },
        };
      
      }
    
      _onClickSubmit() {
        const { history } = this.props;
        history.push('/dashboard/kurikulum/laporan/daftar-nilai-siswa-ktsp');
      }

      _onSubmit() {
        const { history } = this.props;
        history.push('/dashboard/kurikulum/rencana-penilaian/upload');
      }

      _onSubmit2() {
        const { history } = this.props;
        history.push('/dashboard/kurikulum/ulangan/pengisian-indikator-sikap');
      }
      _onSubmit3() {
        const { history } = this.props;
        history.push('/dashboard/kurikulum/laporan/psikomotorik-siswa');
      }
    
    
      _onFormChange(event) {
        const {
          name,
          value,
          dataset,
          checked,
          type,
        } = event.target;
        const {
          inputType = 'text', inputArray = false, arrayPosition = 0,
          fieldName,
        } = dataset;
        this.setState((prevState) => {
          let newList = [];
          let newListError = [];
          let formattedValue = value;
    
          if (inputType === 'number') {
            formattedValue = normalizeAmount(value);
          }
          if (inputArray) {
            if (type === 'checkbox') {
              formattedValue = checked;
            }
            newList = prevState.form.value[fieldName];
            newListError = prevState.form.error[fieldName];
            newList[arrayPosition][name] = formattedValue;
            if (name === 'code_of_account') {
              newList[arrayPosition].isCredit = value.type;
            }
            if (!isEmpty(newListError[arrayPosition])) {
              newListError[arrayPosition][name] = '';
            }
          }
          return {
            form: {
              value: {
                ...prevState.form.value,
                ...(inputArray
                  ? { [fieldName]: newList }
                  : { [name]: formattedValue }),
              },
              error: {
                ...prevState.form.error,
                ...(inputArray
                  ? { [fieldName]: newListError }
                  : { [name]: '' }),
              },
            },
          };
        });
      }
      
    
      render() {
        const {form} = this.state;
        const { handleGetKelas} = this.props;
        return (
          <div className="student-list">
               <div className="budget__title">
                  <h1>A. Create Invoice Individual</h1>
                  <hr></hr>
                </div>
                   <div className="nilai-kognitif__custom-form">
                    <div className="nilai-kognitif__custom-form-row">
                      <div className="nilai-kognitif__custom-form-row__field">
                        <Select
                          name="jenis_invoice"
                          label="Jenis Invoice"
                          onChange={this._onFormChange}
                          data={ '7A', 'kelas7a'}
                          placeholder={'Pilihan'}
                          value={form.value.jenis_invoice}
                          error={form.error.jenis_invoice || ''}
                        />
                      </div>
                      <div className="nilai-kognitif__custom-form-column__field">
                        <Select
                          name="jenis_mata_uang"
                          label="Jenis Mata Uang"
                          onChange={this._onFormChange}
                          value={form.value.jenis_mata_uang || ''}
                          error={form.error.jenis_mata_uang || ''}
                          placeholder={'Pilihan'}
                        />
                      </div>
                      </div>

                      <div className="nilai-kognitif__custom-form-row">
                        <div className="nilai-kognitif__custom-form-row__field">
                          <Select
                            name="classes_year"
                            label="Tahun Ajaran"
                            onChange={this._onFormChange}
                            data={ '7A', 'kelas7a'}
                            placeholder={'Pilihan'}
                            value={form.value.classes_year || ''}
                            error={form.error.classes_year || ''}
                          />
                        </div>
                        <div className="nilai-kognitif__custom-form-column__field">
                          <Input
                              type='text'
                              name="nopsb"
                              label="Nomer PSB/NIS/Nomor Keu"
                              onChange={this._onFormChange}
                              value={form.value.nopsb || ''}
                              error={form.error.nopsb || ''}
                            />
                      </div>
                      </div>

                      <div className="nilai-kognitif__custom-form-row">
                        <div className="nilai-kognitif__custom-form-row__field">
                          <Input
                          type="text"
                            name="namacalon"
                            label="Nama Calon Siswa"
                            onChange={this._onFormChange}
                            data={ '7A', 'kelas7a'}
                            placeholder={'Pilihan'}
                            value={form.value.namacalon || ''}
                            error={form.error.namacalon || ''}
                          />
                        </div>
                      </div>
                    </div>

                      <div className="manage-registration__footer">
                          <Button
                          onClick={this._onSubmit}
                          title="Cari"
                          />
                      </div>

                      <div className="student-list__content">
                        <IndividualForm
                        form={form}
                        onFormChange={this._onFormChange}
                        />
                      </div>
                      <div className="student-list__content">
                        <IndividualTable
                        form={form}
                        onFormChange={this._onFormChange}
                        />
                      </div>
                      <div className="manage-registration__footer">
                          <Button
                          onClick={this._onSubmit}
                          title="Simpan Data"
                          />
                      </div>
          </div>
        );
      }
}
Individual.propTypes = {
    
  handleGetStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
Individual.defaultProps = {
    
  handleGetStudent: noop,
};
